module.exports = __webpack_public_path__ + "static/media/fullmer-logo.9525ffc1.png";